import { fmtDate } from "./format";

/**
 * The crew the planner dispatched on a job, as the backend sends it:
 * `job.dispatchedCrew` = [{ name, role, date }] sorted by day, foreman first.
 * One line per day; a one-day job gets no date prefix. Members with the same
 * role are grouped ("Helpers: Bo Chen, Dan Ho").
 */
export const crewLines = (job) => {
  const crew = (job && Array.isArray(job.dispatchedCrew) ? job.dispatchedCrew : []).filter(
    (m) => m && m.name,
  );
  if (!crew.length) return [];

  const days = [];
  crew.forEach((m) => {
    const date = m.date || "";
    let day = days.find((d) => d.date === date);
    if (!day) {
      day = { date, roles: [] };
      days.push(day);
    }
    const role = m.role || "Crew";
    let group = day.roles.find((r) => r.role === role);
    if (!group) {
      group = { role, names: [] };
      day.roles.push(group);
    }
    group.names.push(m.name);
  });

  const multiDay = days.length > 1;
  return days.map((day) => {
    const members = day.roles
      .map((r) => (r.names.length > 1 ? r.role + "s" : r.role) + ": " + r.names.join(", "))
      .join(" · ");
    if (!multiDay) return members;
    return (day.date ? fmtDate(day.date) : "Date not set") + " · " + members;
  });
};
